

import React, { memo } from 'react';
import { FormModal, Text, Button } from '../../../../ui-kit';

import './styles/_confirmation-modal.scss';







const ConfirmationModalForRushEdit = ({
  visible,
  onClick,
  onClose
}) =>
<div className="confirmation-modal">
    <FormModal
    className="confirmation-modal__form"
    visible={visible}
    onClose={onClose}
    title="Heads Up"
    hideFooter>

      <div className="confirmation-modal__content">
        <span className="confirmation-modal__description">
          Rush edits are subject to Production team capacity.
          Once assessed, your Edit Team Lead will be in touch if we are
          <span className="confirmation-modal__description__unable"> unable </span>
          to service this request.
        </span>
        <Text className="confirmation-modal__description__subject">
          Rush are edits subject to
          {' '}
          <span className="confirmation-modal__description__unable">
&nbsp;2 rounds of amendments
            {' '}
&nbsp;
          </span>
          instead of the usual 5.
        </Text>
      </div>
      <div className="confirmation-modal__button">
        <Button onClick={() => {onClick();onClose();}}>Got It!</Button>
      </div>
    </FormModal>
  </div>;


export default memo(ConfirmationModalForRushEdit);